import type React from "react";

import { SimpleSliderMessageStyled } from "./SimpleSliderStyles";
import { Paragraph, Title } from "@smartsuite/react-ui/lib";

interface SimpleSliderMessageProps {
  subtitle: string;
  title: React.ReactNode;
}

export const SimpleSliderMessage: React.FunctionComponent<
  SimpleSliderMessageProps
> = ({ subtitle, title }) => {
  return (
    <SimpleSliderMessageStyled className="simple-slider-message">
      <div className="simple-slider-message__subtitle">
        <Paragraph
          color="primary"
          size="m"
          align="center"
          weight="semibold"
          transformMode="uppercase"
        >
          {subtitle}
        </Paragraph>
      </div>
      <div className="simple-slider-message__title">
        <Title size="xxxl" color="currentColor" weight="light" align="center">
          {title}
        </Title>
      </div>
    </SimpleSliderMessageStyled>
  );
};
